(function () {
  function norm(s) {
    return String(s || '').trim().toLowerCase();
  }

  function showOnlyAlt(altValue) {
    var wanted = norm(altValue);
    var nodes = document.querySelectorAll('[thumbnail-alt]');
    if (!nodes.length) return;

    // hide/show all tagged nodes (both main slides + thumbnail slides)
    var matched = 0;

    nodes.forEach(function (node) {
      var tag = norm(node.getAttribute('thumbnail-alt'));
      var show =
          tag === wanted ||   // show images for selected color
          tag === 'common' || // show images for all variants
          tag === 'all';      // optional alias
      node.style.setProperty('display', show ? '' : 'none', 'important');
      if (show) matched++;
    });

    // failsafe: if nothing matched, show everything (prevents blank gallery)
    if (wanted && matched === 0) {
      nodes.forEach(function (node) {
        node.style.setProperty('display', '', 'important');
      });
    }
  }

  function activateFirstVisibleMedia() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

    // pick first visible main media item
    var firstVisible = document.querySelector(
      '.product__media-list .product__media-item[thumbnail-alt]:not([style*="display: none"])'
    );
    if (!firstVisible) return;

    var mediaId = firstVisible.getAttribute('data-media-id');
    if (!mediaId) return;

    gallery.setActiveMedia(mediaId, true);
  }

  function getSelectedColorValue() {
    // Works for swatches/radios
    var checked = document.querySelector('variant-selects input[type="radio"]:checked');
    if (checked) return checked.value;

    // Works for selects
    var select = document.querySelector('variant-selects select');
    if (select) return select.value;

    return '';
  }

  function runFilter() {
    var color = getSelectedColorValue();
    showOnlyAlt(color);
    activateFirstVisibleMedia();
  }

  document.addEventListener('change', function (e) {
    if (!e.target.closest('variant-selects')) return;
    setTimeout(runFilter, 0);
  });

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(runFilter, 0);
  });
})();
